export function blurFocus(e: MouseEvent) {
  const el = e.currentTarget
  if (el instanceof HTMLElement && document.activeElement === el) {
    e.preventDefault()
    el.blur()
  }
}
